import { combineReducers } from 'redux';

import checkout from 'dux/checkout/reducers';
import subscriptions from 'dux/subscriptions/reducers';
import { USER_SIGNOUT } from 'dux/auth/actionTypes';
import gifting from 'dux/gift/reducer';
import featureFlags from 'dux/featureFlags/reducers';
import accountCards from 'dux/accountCards/reducers';
import membership from 'dux/membership/reducers';
import giftWithPurchase from 'dux/giftWithPurchase/reducers';
import countries from 'dux/countries/reducers';
import user from 'dux/user/reducers';
import auth from 'dux/auth/reducers';
import feedback from 'dux/feedback/reducers';
import signup from 'dux/signup/reducers';
import support from 'dux/support/reducers';
import consultation from 'dux/consultation/reducers';
import orders from 'dux/orders/reducers';
import selfies from 'dux/selfies/reducers';
import stylist from 'dux/stylist/reducers';
import prescription from 'dux/prescription/reducers';
import products from 'dux/products/reducers';

export default routerReducer => {
  const rootReducer = combineReducers({
    auth,
    signup,
    checkout,
    countries,
    feedback,
    gifting,
    giftWithPurchase,
    orders,
    selfies,
    stylist,
    consultation,
    user,
    subscriptions,
    featureFlags,
    accountCards,
    support,
    membership,
    prescription,
    products,
    router: routerReducer,
  });

  return (state, action) => {
    if (action.type === USER_SIGNOUT) {
      return rootReducer({ router: state.router }, action); // Reset whole state except the router
    }

    return rootReducer(state, action);
  };
};
